import { MailOutlined } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';

export const ButtonCell = <R extends GridValidRowModel = any>(_props: R) => {
  const { t } = useTranslation(I18nNamespace.riskSustainability, { keyPrefix: 'SupplierRisksGrid.column' });
  return (
    <Box>
      <Button startIcon={<MailOutlined />} variant="outlined" size="small" color="primary">
        {t('action')}
      </Button>
    </Box>
  );
};
